import styles from "./typo.module.scss";
export const Title = ({
  text,
  autoWidth = false,
  fontSize = "14px",
  color = "#191919",
  fontWeight = "700",
  maxLine,
  style = {},
}: {
  text: string | React.ReactNode;
  autoWidth?: boolean;
  fontSize?: string;
  color?: string;
  fontWeight?: string;
  maxLine?: number;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={`${styles["title"]} ${maxLine ? styles[`line-clamp-${maxLine}`] : ""}`}
      style={{
        width: autoWidth ? "auto" : "100%",
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: color,
        ...style,
      }}
    >
      {text}
    </div>
  );
};
